import DB from '../DB';

type Task = { status: 'IN_PROGRESS' | 'COMPLETED'; updatedAt: number };

export function createDevDBTasks(
    fetchTask: (id: string) => Task,
    writeTask: (id: string, task: Task) => void,
): DB<any>['tasks'] {
    return {
        completeTask: async (id, now) => {
            const task = fetchTask(id);
            if (!task) {
                throw Error('Cannot complete non-existent task');
            }
            if (task.status === 'COMPLETED') {
                throw Error('Cannot complete an already completed task');
            }

            writeTask(id, { status: 'COMPLETED', updatedAt: now });
        },

        fetchTasks: async (ids, now, expiresInMs) => {
            const result: { [id: string]: 'COMPLETED' | 'IN_PROGRESS' } = {};

            for (const id of ids) {
                const task = fetchTask(id);
                if (task?.status === 'COMPLETED') {
                    result[id] = 'COMPLETED';
                } else if (task?.status === 'IN_PROGRESS' && now < task.updatedAt + expiresInMs) {
                    result[id] = 'IN_PROGRESS';
                }
            }

            return result;
        },

        tryWriteLock: async (id, now, expiresInMs) => {
            const task = fetchTask(id);
            if (!task || (task.status === 'IN_PROGRESS' && task.updatedAt <= now - expiresInMs)) {
                writeTask(id, { status: 'IN_PROGRESS', updatedAt: now });
                return true;
            }

            return false;
        },
    };
}
